import { render, staticRenderFns } from "./EditarAnexos.vue?vue&type=template&id=08713936&scoped=true&"
import script from "./EditarAnexos.vue?vue&type=script&lang=js&"
export * from "./EditarAnexos.vue?vue&type=script&lang=js&"
import style0 from "./EditarAnexos.vue?vue&type=style&index=0&id=08713936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08713936",
  null
  
)

export default component.exports